/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import { bool, func, arrayOf, object, string } from 'prop-types';
import ConvocationsActions from 'store/ducks/convocations';
import { actions as toastrActions } from 'react-redux-toastr';

import { Container, ContainerModal, Card, WrapperCenter } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import Images from 'assets/img';
import { Close } from '@material-ui/icons';
import ButtonModal from 'components/ButtonModal';

export default function DeleteModal({ open, reload, onClose }) {
  const dispatch = useDispatch();
  const { convocationActive, successDelete } = useSelector(
    (state) => state.convocations
  );

  const handleDelete = () => {
    if (convocationActive && convocationActive.id) {
      dispatch(ConvocationsActions.removeConvocationRequest(convocationActive.id));
    }
  };

  // Exibir toast quando a exclusão for bem-sucedida e fechar o modal
  useEffect(() => {
    if (successDelete) {
      dispatch(
        toastrActions.add({
          type: 'success',
          title: 'Sucesso',
          message: 'Carga excluída com sucesso!',
        })
      );
      // Fechar o modal após exibir o toast
      setTimeout(() => {
        dispatch(ConvocationsActions.closeDeleteModal());
      }, 100);
    }
  }, [successDelete, dispatch]);

  return (
    <Container>
      <Card>
        <ContainerModal>
          <h3>Excluir carga</h3>
          <p>Você gostaria de excluir esta carga?</p>
          <WrapperCenter>
            <ButtonModal
              onClick={() => dispatch(ConvocationsActions.closeDeleteModal())}
              type="secondary"
              width="80px"
              label="Não"
            />
            <ButtonModal
              onClick={handleDelete}
              label="Sim"
              width="80px"
              margin="0 0 0 24px"
            />
          </WrapperCenter>
        </ContainerModal>
      </Card>
    </Container>
  );
}

DeleteModal.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
};
